import { NgModule } from '@angular/core';
import { CmsComponent } from './cms.component';

@NgModule({
  imports: [
  ],
  declarations: [CmsComponent],
  exports: [CmsComponent]
})
export class CmsModule { }
